module.exports = __webpack_public_path__ + "img/magnify.d02102f2.png";